import { ReactComponent as LockSvg } from 'src/assets/icons/lock.svg';
import styled from 'styled-components';

export const LockIcon = styled(LockSvg)`
  height: 29px;
`;
